export const SCORE_WEIGHTS = {
  'factual-accuracy': 0.6,
  'response-relevancy': 0.25,
  'context-conciseness': 0.15,
} as const;

export type ScoreType = keyof typeof SCORE_WEIGHTS;

export const calculateWeightedScore = (scores: { name: string; score: number }[]): number => {
  const totalWeight = scores.reduce((sum, { name }) => {
    const weight = SCORE_WEIGHTS[name as ScoreType] || 0;
    return sum + weight;
  }, 0);

  const weightedSum = scores.reduce((sum, { name, score }) => {
    const weight = SCORE_WEIGHTS[name as ScoreType] || 0;
    return sum + score * weight;
  }, 0);

  return totalWeight === 0 ? 0 : weightedSum / totalWeight;
};
